import React, { useEffect, useMemo, useState } from "react";
import Pagetitle from "../elements/Pagetitle";

const pads = ["#f9d74c", "#f97b8b", "#6c6ce5", "#44d7b6"];
const padLabels = ["A", "B", "C", "D"];

function Games() {
  const [score, setScore] = useState(0);
  const [target, setTarget] = useState({ left: 56, top: 42 });
  const [pulse, setPulse] = useState(false);
  const [sequence, setSequence] = useState([0, 2, 1]);
  const [input, setInput] = useState([]);
  const [memoryMessage, setMemoryMessage] = useState("Repeat the pattern.");
  const [spin, setSpin] = useState(0);
  const [spinMessage, setSpinMessage] = useState("Spin the signal wheel.");

  const targetStyle = useMemo(
    () => ({
      left: `${target.left}%`,
      top: `${target.top}%`,
    }),
    [target]
  );

  useEffect(() => {
    if (!pulse) return undefined;
    const timer = setTimeout(() => setPulse(false), 280);
    return () => clearTimeout(timer);
  }, [pulse]);

  const moveTarget = () => {
    setScore(score + 1);
    setTarget({
      left: 12 + Math.round(Math.random() * 72),
      top: 18 + Math.round(Math.random() * 58),
    });
    setPulse(true);
  };

  const resetReflex = () => {
    setScore(0);
    setTarget({ left: 56, top: 42 });
  };

  const nextSequence = () => {
    setSequence([...sequence, Math.floor(Math.random() * pads.length)]);
    setInput([]);
    setMemoryMessage("Pattern upgraded.");
  };

  const pressPad = (index) => {
    const nextInput = [...input, index];
    setInput(nextInput);

    if (sequence[nextInput.length - 1] !== index) {
      setInput([]);
      setSequence([0, 2, 1]);
      setMemoryMessage("Signal scrambled. Start again.");
      return;
    }

    if (nextInput.length === sequence.length) {
      setMemoryMessage(`Clean run: ${sequence.length} beats.`);
      setTimeout(nextSequence, 350);
    } else {
      setMemoryMessage(`${sequence.length - nextInput.length} beats left.`);
    }
  };

  const spinWheel = () => {
    const nextSpin = spin + 360 + Math.floor(Math.random() * 720);
    const rewards = ["Hyper focus", "Bug shield", "Coffee mode", "Ship it"];
    setSpin(nextSpin);
    setSpinMessage(rewards[Math.floor(Math.random() * rewards.length)]);
  };

  return (
    <section id="games" className="games-section">
      <div className="container">
        <Pagetitle title="Playground" />
        <div className="games-grid">
          <div className="game-card reflex-game">
            <div className="game-card-header">
              <span>Reflex Field</span>
              <strong>{score}</strong>
            </div>
            <div className={pulse ? "game-arena pulse" : "game-arena"}>
              <button
                aria-label="Catch target"
                className="reflex-target"
                onClick={moveTarget}
                style={targetStyle}
              ></button>
              <span className="scanner-line"></span>
            </div>
            <button className="game-action" onClick={resetReflex}>
              Reset score
            </button>
          </div>

          <div className="game-card memory-game">
            <div className="game-card-header">
              <span>Signal Memory</span>
              <strong>{sequence.length}</strong>
            </div>
            <div className="sequence-preview">
              {sequence.map((item, index) => (
                <span
                  className="sequence-dot"
                  key={`${item}-${index}`}
                  style={{ backgroundColor: pads[item] }}
                ></span>
              ))}
            </div>
            <div className="pad-grid">
              {pads.map((color, index) => (
                <button
                  className="memory-pad"
                  key={color}
                  onClick={() => pressPad(index)}
                  style={{ backgroundColor: color }}
                >
                  {padLabels[index]}
                </button>
              ))}
            </div>
            <p>{memoryMessage}</p>
          </div>

          <div className="game-card spin-game">
            <div className="game-card-header">
              <span>Deploy Spinner</span>
              <strong>GO</strong>
            </div>
            <button className="spinner-core" onClick={spinWheel}>
              <span style={{ transform: `rotate(${spin}deg)` }}></span>
            </button>
            <p>{spinMessage}</p>
            <button className="game-action" onClick={spinWheel}>
              Spin again
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Games;
